<template>
  <section id="shows">
    <h1>Shows</h1>
    <div class="row"> <!--itemscope itemtype=http://schema.org/Event -->
      <div class="columns medium-6">
        <article class=details></article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Shows',
  data: function() {
    return {
      /*
      oldShows: [
        {
          'name': 'Taste of Chicago',
          'dateAndTime': 'Saturday, July 9 at 6:40pm',
          'bill': [
            'Prince Rama'
          ],

          'link': 'http://www.lh-st.com/Shows/04-08-2016+Prince+Rama+',
          linkText: '>Bud Light Stage'
          </p>
          <p>
            <span itemprop=location itemscope itemtype=http://schema.org/Place>
              <a itemprop="url" href=http://www.lh-st.com/Shows/04-08-2016+Prince+Rama+>Bud Light Stage</a></span>
              <span>,</span>
              <span>All Ages </span>
              <span itemprop=offers itemscope itemtype=http://schema.org/AggregateOffer>
              <span itemprop=lowPrice>Free</span>
            </span>
          </p>
          <p>
            <a target=_blank href=http://www.lh-st.com/Shows/04-08-2016+Prince+Rama+>Tickets</a>
          </p>
          <p>
            <a target=_blank href="https://www.google.com/maps/place/Central,+Chicago,+IL+60605/@41.873223,-87.6227676,17z/data=!3m1!4b1!4m5!3m4!1s0x880e2c9fafb57de9:0x3038f91afe82c84d!8m2!3d41.873223!4d-87.6205789">Map</a>
          </p>
        </article>
      </div>
        }, {
          <div class="columns medium-6">
        <article class=details>
          <h3>Move Dance Feel Release Show</h3>
          <p itemprop=startDate content="2016-04-08T10:00">
            Friday August 12th, 2016, 9pm
          </p>
          <p>
            <span itemprop=location itemscope itemtype=http://schema.org/Place>
              <a itemprop=url href=http://www.lh-st.com/Shows/08-12-2016+Madaila>Schubas Tavern</a>
              </span>
              <span>, </span>
              <span>21+</span>
              <span itemprop=offers itemscope itemtype=http://schema.org/AggregateOffer>
              <span itemprop=lowPrice>$12</span>
            </span>
          </p>
          <p>
            with:
            <a href="http://www.musicofmadaila.com/">MADAILA</a>,
            <a href="http://www.swearwordsmusic.com/">SWEARWORDS</a>
          </p>
          <p>
            <a target=_blank href=http://www.lh-st.com/Shows/08-12-2016+Madaila>Tickets</a>
          </p>
          <p>
            <a target=_blank href="https://www.google.com/maps/place/Schubas+Tavern/@41.9396435,-87.6657194,17z/data=!3m1!4b1!4m2!3m1!1s0x880fd256a355a137:0x13dea84aff910349">
              Map
            </a>
          </p>
        </article>
      </div>
    </div>
        },
      ]*/
    };
  },
};
</script>
